import mergeCapabilityPatch from '@/lib/settings/rolePermissions/mergeRoleCapabilityPatch.js';

const mergeUserCapabilityPayload = ({ currentPayload, patchPayload } = {}) => {
  const basePayload = currentPayload && typeof currentPayload === 'object' ? currentPayload : null;
  const nextPayload = patchPayload && typeof patchPayload === 'object' ? patchPayload : null;

  return {
    ...(basePayload || {}),
    ...(nextPayload || {}),
    capabilities: mergeCapabilityPatch({
      currentValue: basePayload?.capabilities || {},
      patchValue: nextPayload?.capabilities || {}
    }),
    roleCapabilities: mergeCapabilityPatch({
      currentValue: basePayload?.roleCapabilities || {},
      patchValue: nextPayload?.roleCapabilities || {}
    })
  };
};

export default mergeUserCapabilityPayload;
